import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=53376398&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53376398')) {
      api.createRecord('53376398', component.options)
    } else {
      api.reload('53376398', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=53376398&", function () {
      api.rerender('53376398', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QJr7G3fb1Rv2/JS/offershelp.vue"
export default component.exports